import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LibModule } from '@ui-components/lib.module';
import { B2cPaymentComponent } from './b2c-payment.component';
import { LibContentLoaderModule } from '@ui-components/content-loader';
import { LibButtonModule } from '@ui-components/button';

@NgModule({
  declarations: [
    B2cPaymentComponent
  ],
  imports: [
    CommonModule,
    LibModule
  ],
})
export class B2cPaymentModule { }
